import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authExchangeSession } from '../api';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await authExchangeSession(sessionId);
        setUser(user);
        // Clean URL hash and go to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/Dashboard', { replace: true, state: { user } });
      } catch (err) {
        console.error('OAuth exchange failed', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#2563eb] mx-auto mb-3" />
        <div className="text-[#111827]/70 text-sm">Signing you in...</div>
      </div>
    </div>
  );
};

export default AuthCallback;
